import { Status } from 'app/shared/model/enumerations/status.model';

export interface IParCountry {
  id?: number;
  code?: string;
  name?: string;
  nameAr?: string;
  nameFrench?: string;
  status?: Status;
}

export const defaultValue: Readonly<IParCountry> = {};
